// Option lists for the Call for Non-Technical Advisors form.
// Lists with a "(specify)" suffix on the last entry let the user add free text.

export const GENDER_OPTIONS = ["Female", "Male"] as const;

export const RATING_1_TO_5 = [1, 2, 3, 4, 5] as const;

// "Which of the following do you have experience in?"
export const EXPERIENCE_TYPES = [
  "Mentoring Services",
  "Coaching",
  "Advisory",
  "Consulting",
  "I'm new to this",
] as const;

export const YES_NO = ["Yes", "No"] as const;

export const YEARS_OF_EXPERIENCE = [
  "less than 5",
  "5-10",
  "more than 10",
] as const;

// "Non-Technical: In which subjects do you possess experience?"
// Original is free-text. We provide a curated multi-select + Other.
export const NON_TECHNICAL_SUBJECTS = [
  "Business Advisory",
  "Business Analysis",
  "Business Development",
  "Strategic Planning",
  "Sales",
  "Marketing and Branding",
  "Communications",
  "Public Relations",
  "Fundraising",
  "Investment / Venture Capital",
  "Financial Management",
  "Operations",
  "Project Management",
  "Product Management",
  "Customer Success",
  "Go-to-market planning",
  "HR and Talent Management",
  "Recruitment",
  "Leadership Development",
  "Change Management",
  "Digital Transformation",
  "Design Thinking",
  "Entrepreneurship and Innovation",
  "Legal / Compliance",
  "Data Analysis",
  "AI Strategy",
  "Education and Training",
] as const;

// "Technical: In which specializations or technologies are you experienced in?"
export const TECHNICAL_SPECIALIZATIONS = [
  "Software Engineering (general)",
  "Frontend Development",
  "Backend Development",
  "Full Stack Development",
  "Mobile Development (iOS / Android)",
  "Data Science",
  "Data Engineering",
  "Machine Learning / AI",
  "DevOps / Cloud Infrastructure",
  "Cybersecurity",
  "QA / Test Engineering",
  "UI / UX Design",
  "Product Design",
  "Game Development",
  "Blockchain",
  "Embedded Systems / IoT",
  "Robotics",
  "Engineering Management",
  "Technical Architecture",
  "Cloud Architecture (AWS / GCP / Azure)",
] as const;

export const PAID_OR_VOLUNTEER = ["Paid", "Volunteering", "Open to both"] as const;

export const HEAR_ABOUT_US = [
  "LinkedIn",
  "GSG Newsletter",
  "GSG website",
  "From a GSG team member",
  "From a friend or colleague",
  "Mercy Corps",
  "Booking.com volunteering / Benevity",
  "TechPals community",
  "University event or society",
  "Conference or workshop",
  "Social media (other)",
  "Web search",
] as const;

// "Which of the following ways would you be interested in engaging with Palestinian talent?"
export const ENGAGEMENT_WAYS = [
  "Working with companies",
  "Training for individuals",
  "Offering internship opportunities",
  "Providing employment opportunities",
] as const;

// "I would like to support in:"
export const SUPPORT_AREA = ["Technical", "Non-Technical"] as const;

// "I am interested in supporting GSG through"
export const SUPPORT_MODES = [
  "Mentorship: Experienced guide offering support for individuals",
  "Coaching: Help improve specific skills",
  "Advisory: Provide expert strategic advice",
  "Consulting: Offer expert problem-solving services",
] as const;

// "Which markets/regions do you have professional experience working in?"
export const MARKETS = [
  "Palestine",
  "Levant (Jordan, Lebanon, Syria, Iraq)",
  "Gulf (UAE, Saudi Arabia, Qatar, Kuwait, Bahrain, Oman)",
  "Egypt",
  "North Africa (Morocco, Tunisia, Algeria, Libya)",
  "Wider MENA",
  "Sub-Saharan Africa",
  "Europe",
  "United Kingdom and Ireland",
  "North America (US and Canada)",
  "Latin America",
  "South Asia",
  "East Asia and Pacific",
  "Australia and New Zealand",
  "Global / Cross-regional",
] as const;

// ISO 3166 country list, English short names.
export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
  "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain",
  "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
  "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
  "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada",
  "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros",
  "Congo (Brazzaville)", "Congo (Kinshasa)", "Costa Rica", "Cote d'Ivoire",
  "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica",
  "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea",
  "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France",
  "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala",
  "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland",
  "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica",
  "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan",
  "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein",
  "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali",
  "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
  "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar",
  "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger",
  "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",
  "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines",
  "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis",
  "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
  "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles",
  "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia",
  "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan",
  "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",
  "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia",
  "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",
  "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu",
  "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe",
] as const;

// ---- Mentor track (questions provided by Haneen) ----

export const STUDY_LEVELS = ["Bachelor", "Masters", "PHD"] as const;

export const MENTOR_HOURS = ["2-3", "4-5", "6+"] as const;

export const MENTOR_FREQUENCY = ["Weekly", "Bi-weekly", "Monthly"] as const;

export const MENTOR_MODELS = [
  "One to One",
  "Group Mentorship",
  "Short-Term / Cohort-Based training",
  "Expert session Mentorship",
] as const;

export const MENTEE_PREFERENCES = [
  "One Mentee",
  "Two mentees",
  "Open to mentoring more than two mentees, having them together in the same session",
  "Open to mentoring more than two mentees separately",
] as const;

export const GUIDANCE_TYPES = [
  "Technical & Sector Expertise",
  "Employability & Career Development",
  "Soft Skills & Professional Growth",
  "Education & Academic Pathways",
  "Other",
] as const;
